import { api } from './api';
export const notificationsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // 获取通知列表
        getNotifications: builder.query({
            query: () => '/notifications',
            providesTags: ['Notification'],
        }),
        // 获取未读通知数
        getUnreadCount: builder.query({
            query: () => '/notifications/unread/count',
            providesTags: ['Notification'],
        }),
        // 标记为已读
        markAsRead: builder.mutation({
            query: (id) => ({
                url: `/notifications/${id}/read`,
                method: 'PUT',
            }),
            invalidatesTags: ['Notification'],
        }),
        // 标记全部为已读
        markAllAsRead: builder.mutation({
            query: () => ({
                url: '/notifications/read-all',
                method: 'PUT',
            }),
            invalidatesTags: ['Notification'],
        }),
        // 删除通知
        deleteNotification: builder.mutation({
            query: (id) => ({
                url: `/notifications/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Notification'],
        }),
        // 清空所有通知
        clearAll: builder.mutation({
            query: () => ({
                url: '/notifications/clear',
                method: 'DELETE',
            }),
            invalidatesTags: ['Notification'],
        }),
    }),
});
export const { useGetNotificationsQuery, useGetUnreadCountQuery, useMarkAsReadMutation, useMarkAllAsReadMutation, useDeleteNotificationMutation, useClearAllMutation, } = notificationsApi;
